import React from "react"
import { Link } from "gatsby"
import HeroImage from "../../images/demo-hero.png"

import HeroStyles from "./hero.module.scss"

/*
    TODO: Remove name from hero section
    
    Image URL: https://unsplash.com/photos/pu20JkUx--A
*/

const Hero = () => (
  <header className={HeroStyles.hero}>
    <div className={HeroStyles.heroText}>
      {/* Don't put name here and in navbar */}
      <h1>Eclipperz </h1>
      <p>The barbershop management system of the future</p>
      <Link to="/cue/" className={`button ${HeroStyles.button}`}>
        View Demo
      </Link>
      <Link to="/about/" className="btn--outlined">
        Learn More
      </Link>
    </div>
    <img
      className={HeroStyles.hero__image}
      src={HeroImage}
      alt="People holding mobile devices"
    />
  </header>
)

export default Hero
